/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { setIsFullOptionsShown } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
import showQuickOptionsAction from 'owa-options-actions/lib/showQuickOptions';
export default orchestratorAction('hideFullOptions', function hideFullOptions(showQuickOptions) {
    var continueAfterConfirmCallback = function () {
        setIsFullOptionsShown(false);
        if (showQuickOptions) {
            showQuickOptionsAction();
        }
    };
    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
//# sourceMappingURL=hideFullOptions.js.map